import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

export type AdditionalPersonSkill = {
	additional_skills: string[];
};

export const getAdditionalPersonSkillsById = (
	personId: number,
	assignmentId?: number
): Promise<DRFListResponseWrapper<AdditionalPersonSkill[]>> => {
	if (!personId || typeof personId !== "number") {
		throw new Error(
			`getAdditionalPersonSkillsById called with invalid argument id '${personId}'. Expected number`
		);
	}

	const url = new URL(
		`/api/v2/persons/${personId}/additionalskills/`,
		window.location.origin
	);
	if (assignmentId) {
		url.searchParams.append("highlight", assignmentId.toString());
	}

	return fetch(url.toString(), {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
